var _path, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook_svg__a)",
    fillRule: "evenodd",
    d: "M30.203 42.23V29.25h4.358l.653-5.06h-5.01v-3.23c0-1.465.406-2.464 2.507-2.464l2.68-.001v-4.526c-.464-.061-2.054-.2-3.905-.2-3.863 0-6.508 2.359-6.508 6.69v3.73H20.61v5.06h4.37v12.983h5.224Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#00CA72",
    rx: 27.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebook_svg__a",
    x1: 35.571,
    x2: 20.602,
    y1: 27.56,
    y2: 27.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CA72",
    stopOpacity: 0.2
  })))));
};
export default SvgFacebook;